module.exports = __webpack_public_path__ + "img/img_4.eadd6f13.png";